import { z, type ZodType } from 'zod';

import ReturnReason from '../ReturnReason';
import ReturnItemType from './ReturnItemType';
import type { IExchangeItem } from './IExchangeItem';
import type { IRefundItem } from './IRefundItem';
import type { ReturnItem } from './ReturnItem';

export const BaseReturnItemSchema = z.object({
  id: z.string(),
  displayName: z.string(),
  color: z.string(),
  imageUrl: z.string(),
  itemSKU: z.string(),
  itemUPC: z.string()
});

/**
 * Schema for a refund item.
 */
export const RefundItemSchema = BaseReturnItemSchema.extend({
  returnType: z.literal(ReturnItemType.Refund),
  returnReason: z.nativeEnum(ReturnReason)
}) satisfies ZodType<IRefundItem>;

/**
 * Schema for an exchange item.
 */
export const ExchangeItemSchema = BaseReturnItemSchema.extend({
  returnReason: z.nativeEnum(ReturnReason),
  returnType: z.union([
    z.literal(ReturnItemType.SameSKUExchange),
    z.literal(ReturnItemType.SameModelExchange),
    z.literal(ReturnItemType.DifferentModelExchange)
  ]),
  exchangeItemSKU: z.string(),
  exchangeItemUPC: z.string(),
  exchangeItemPrice: z.number(),
  isEvenExchange: z.boolean()
}) satisfies ZodType<IExchangeItem>;

/**
 * Union schema that validates any kind of return item
 * (either a refund item or an exchange item).
 */
export const ReturnItemSchema = z.union([
  RefundItemSchema,
  ExchangeItemSchema
]) satisfies ZodType<ReturnItem>;
